__turbopack_context__.v({
  "actionIconWrapper": "_7TTvcq_actionIconWrapper",
  "backButton": "_7TTvcq_backButton",
  "modal": "_7TTvcq_modal",
  "moreToolsButton": "_7TTvcq_moreToolsButton",
  "toggleButton": "_7TTvcq_toggleButton",
  "versionInformation": "_7TTvcq_versionInformation",
  "versionInformationLink": "_7TTvcq_versionInformationLink",
});
